import { Link, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const AllLink = styled(Link)`
  margin-right: 0.75em;
  font-size: 18px;
  &.MuiLink-root {
    &:hover {
      text-decoration: underline;
    }
  }
  ${variables.mediaQuery.lessThan('tablet')`
     font-size: 16px;
     margin-left: 1em;
  `}
`;

export const PageFilters = styled.div`
  display: flex;
  grid-gap: 1rem;
  padding: 16px 24px;
  flex-direction: row;
  align-items: center;
  background: ${variables.color.navy95};
  box-shadow: 0px 4px 10px 0px rgba(29, 75, 122, 0.1);
  border-radius: 5px;
  margin: 24px 0 12px;

  ${variables.mediaQuery.lessThan('desktop')`

     flex-wrap: wrap;
  `}
`;
